// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","header":"T6vFqnSrTGk9JKxa2wwz","nav":"YnqoFuJ2f3neZL5LvFxm","tabview":"mS9Q0frRCHzf6Nhhia7P"};